import React from 'react'

export default class UserInputCheckbox extends React.Component
{
	constructor(props)
	{
		super(props);
		
		this.keyCount = 0 ;

		var defaultValue = false ;

		if ( this.props.defaultValue != null )
		{
			defaultValue = this.props.defaultValue ;
		}
		
    	// Create a state item here for all items on the form  (Using their id )
		this.state = {
			val: defaultValue, 
			dirty: false, 
			valid: this.isValueValid(this.props.defaultValue)};
		
	}

	sendChangeNotification()
	{
		if ( this.state.dirty == false )
		{
			if ( this.props.onDirty != null )
			{
				// Send a dirty notification if required, and only the first time we change
				this.props.onDirty() ;
			}
		}
	}

	handleInputChange(event) 
	{
		if ( this.props.readOnly != 'readonly' )
		{
			var isValid = this.isValueValid(event.target.checked) ;
			
			this.setState({ val: event.target.checked, dirty: true, valid: isValid });

			this.sendChangeNotification();

			if ( this.props.onChange != null )
			{
				this.props.onChange ( event.target.checked ) ;
			}						
		}
	}

    /**
     * Sets the initial 'valid' state and value when the initial props are supplied
     * 
     * @param {props} nextProps - props object passed by React.
     * @return {void} 
     */
	UNSAFE_componentWillReceiveProps(nextProps)
	{
		if ( nextProps.value != this.props.value )
		{
			var isValid = this.isValueValid(nextProps.value) ;
		
			// Set our initial validity state
			this.setState ( { val: nextProps.value, valid: isValid }) ;
		}
	}
	
    /**
     * Returns true if the input value complies with the validation rules supplied
     * 
     * @param {string} param - The value of the string to be tested.
     * @return {bool} true if the test passes.
     */
	isValueValid( param )
	{
		return true ;
	}
		
    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	isValid()
	{		
		return this.isValueValid ( this.state.val ) ;
	}

    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	isDirty()
	{		
		return this.state.dirty ;
	}

    /**
     * Externally callable function to test if the input field is valid
     * 
     * @return {bool} True if the field is valid.
     */
	setDirty( value )
	{		
		this.setState ({ dirty: value }) ;
	}

    /**
     * External function to return the value of the input field
     * 
     * @return {string} THe value of the input field.
     */
	getValue()
	{
		return this.state.val ;
	}
	
    /**
     * Generates HTML for the error DIV which wil be visible if the field contents are
     * invalid AND the this.props.displayErrors flag is set. This will generally be set 
     * by the parent form if error display is required.
     * 
     * @param {bool} validFlag - True if this field is currnetly invalid.
     * @return {void} 
     */
	errorDiv ( validFlag )
	{
		var errmsg = "&nbsp;";
		
		if ( this.props.errorText != null )
		{
			if ( this.props.errorText.length != 0)
			{
				errmsg = this.props.errorText ;
			}
		}

		var className = 'input-error-invisible' ;
		
		if ( this.props.displayErrors == true && this.isValid() != true  )
		{
			className = 'input-error-visible' ;
		}
		
		return React.createElement ('div', {  htmlFor: this.props.id, key: this.keyCount++, className: className} , errmsg ) ;		
	}
	
	
	inputCollection()
	{
        var lineList=[];
        
        var v = this.state.val ;

		const disabled = this.props.readOnly === 'readonly' ? 'disabled' : '' ;
        
        lineList.push ( React.createElement('input',{ 
        	key: this.keyCount++, 
        	readOnly: this.props.readOnly,
        	tabIndex: this.props.tabIndex,
			disabled: disabled,
        	type: 'checkbox',  
        	checked: this.state.val,
			id: this.props.id,
			name: this.props.name, 
			onChange: this.handleInputChange.bind(this) }, null )) ;
        
        lineList.push ( this.props.label ) ;
        
        return lineList ;        
	}
	
	label()
	{

        return React.createElement ( 'label', {}, this.inputCollection()) ;
	}		

	
	checkBoxControl()
	{
        var lineList=[];
        
		 lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'checkbox'}, this.label()));			
		 
        if ( this.props.displayErrors == true )
    	{
            lineList.push ( this.errorDiv(this.isValid()) ) ;    	
    	}
	     
	     return lineList ;
	}

	renderedComponent()
	{
    	return (React.createElement ('div', {  key: this.props.keyValue, className: 'input-group' }, this.checkBoxControl())) ;
	}
	
    render() 
    {
    	this.keyCount = 0 ;

    	return this.renderedComponent() ;    	
    }
};
